import React, { memo } from "react";
import Shimmer from "react-shimmer-effect";

const GastronomyCardLoader = () => {
  return (
    <div
      className="flex flex-col m-8 shadow-lg rounded justify-between"
      style={{ minWidth: "25rem" }}
    >
      <Shimmer>
        <div
          className="w-full h-40 flex bg-cover rounded-t overflow-hidden"
          style={{ backgroundSize: "800px 100%" }}
        ></div>
      </Shimmer>
      <div className="bg-white rounded p-4 flex flex-col justify-between leading-normal">
        <div className="flex items-center mb-8">
          <Shimmer>
            <div className="w-10 h-10 rounded-full mr-4"></div>
          </Shimmer>
          <div>
            <Shimmer>
              <div className="w-48 h-5"></div>
            </Shimmer>
            <Shimmer>
              <div className="w-32 h-5"></div>
            </Shimmer>
          </div>
        </div>
        <div className="flex flex-col mb-8">
          <Shimmer>
            <div className="w-32 h-16"></div>
          </Shimmer>
        </div>
        <div className="flex items-center">
          <Shimmer>
            <div className="w-32 h-8 rounded-full mr-2"></div>
          </Shimmer>
          <Shimmer>
            <div className="w-32 h-8 rounded-full"></div>
          </Shimmer>
        </div>
      </div>
    </div>
  );
};

export default memo(GastronomyCardLoader);
